<template>
  <div>
    <div class="__nuxt-error-page">
      <div class="error">
        <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" fill="#ccd0d5" viewBox="0 0 48 48">
          <path d="M22 30h4v4h-4zm0-16h4v12h-4zm1.99-10C12.94 4 4 12.95 4 24s8.94 20 19.99 20S44 35.05 44 24 35.04 4 23.99 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16z" />
        </svg>

        <div class="title">{{ message }}</div>
        <p class="description">
          <nuxt-link class="error-link" :to="redirectPath">
            <i class="fa fa-angle-double-left" style="margin-right: 5px;"></i>
            {{redirectText}}
          </nuxt-link>
        </p>

        <div class="logo">
          <a href="/" target="_blank" rel="noopener"><img src="/frontend/img/logo-c.png" srcset="/frontend/img/logo-c.png 1x, /frontend/img/logo-c@2x.png 2x"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NuxtError',
    props: {
      error: {
        type: Object,
        default: null
      }
    },
    computed: {
      statusCode () {
        return (this.error && this.error.statusCode) || 500
      },
      message () {
        return this.error.message || 'Error'
      },
      redirectPath () {
        return this.error.redirectPath || '/dashboard'
      },
      redirectText () {
        return this.error.redirectText || 'トップページに戻る'
      }
    },
    head () {
      return {
        title: `Error ${this.statusCode}`,
        meta: [
          {
            name: 'viewport',
            content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
          }
        ]
      }
    }
  }
</script>

<style scoped>
.__nuxt-error-page {
  padding: 1rem;
  background: #f9fafc;
  color: #47494e;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: sans-serif;
  font-weight: 100 !important;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.__nuxt-error-page .error,
.__nuxt-error-page .success {
  max-width: 450px;
}

.__nuxt-error-page .title {
  font-size: 24px;
  margin-top: 15px;
  color: #47494e;
  margin-bottom: 8px;
}

.__nuxt-error-page .description {
  color: #7f828b;
  line-height: 21px;
  font-size: 16px;
  margin-bottom: 10px;
}

.__nuxt-error-page a {
  color: #7f828b !important;
  text-decoration: none;
}

.__nuxt-error-page .logo {
  position: fixed;
  left: 12px;
  bottom: 12px;
}

</style>